"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M2 3V1H14V4",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14 15L2 15L2 3",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.16602 9.88599V12H5V6H7.20766C7.63261 6 8.00574 6.08242 8.32704 6.24725C8.65093 6.41209 8.89969 6.64698 9.07329 6.95192C9.2469 7.25412 9.3337 7.5989 9.3337 7.98626C9.3337 8.57418 9.14325 9.03846 8.76235 9.37912C8.38405 9.71703 7.85934 9.88599 7.18823 9.88599H6.16602ZM6.16602 8.88462H7.20766C7.51601 8.88462 7.75051 8.80769 7.91116 8.65385C8.0744 8.5 8.15602 8.28022 8.15602 7.99451C8.15602 7.70055 8.0744 7.46291 7.91116 7.28159C7.74792 7.10027 7.52249 7.00687 7.23487 7.00137H6.16602V8.88462Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.1383 12V6H11.8795C12.377 6 12.8214 6.11951 13.2127 6.35852C13.6065 6.59478 13.9136 6.93269 14.1338 7.37225C14.3541 7.80907 14.4642 8.30632 14.4642 8.86401V9.14011C14.4642 9.6978 14.3554 10.1937 14.1377 10.6277C13.9226 11.0618 13.6182 11.3984 13.2243 11.6374C12.8305 11.8764 12.3861 11.9973 11.8912 12H10.1383ZM11.3043 7.00137V11.0069H11.8679C12.3239 11.0069 12.6724 10.8489 12.9134 10.533C13.1544 10.217 13.2774 9.76511 13.2826 9.1772V8.85989C13.2826 8.25 13.1634 7.78846 12.925 7.47527C12.6867 7.15934 12.3381 7.00137 11.8795 7.00137H11.3043Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M18.7202 9.54808H16.4814V12H15.3154V6H19V7.00137H16.4814V8.55082H18.7202V9.54808Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;